import { Fragment, ReactElement } from 'react';
import ResearchDeathNotificationResidentCivilStatusShared from 'shell/components/shared/research-notifications-civil-status-registry-office/research-death';
import { IdAmbito } from 'shell/constants/id-ambito';

const ResearchDeathNotificationResidentCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <ResearchDeathNotificationResidentCivilStatusShared scope={IdAmbito.Mutazioni} />
    </Fragment>
  );
};

ResearchDeathNotificationResidentCivilStatusPage.displayName =
  'Research Marriage Notifications Resident Page component';

export default ResearchDeathNotificationResidentCivilStatusPage;
